export function previousReleaseLabel(
  historyOldestFirst: Array<{ label?: string }>,
): string | undefined {
  if (historyOldestFirst.length < 2) return undefined;
  return historyOldestFirst[historyOldestFirst.length - 2]?.label;
}

export function isPinnedRollbackApplied(
  latest: { label?: string; releaseMethod?: string; originalLabel?: string } | undefined,
  pinnedLabel: string,
): boolean {
  if (!latest) return false;
  if (latest.label === pinnedLabel) return true;
  return latest.releaseMethod === "Rollback" && latest.originalLabel === pinnedLabel;
}
